export const normalMargins = {
  'margin-top': '0.75in',
  'margin-bottom': '0.75in',
  'margin-left': '0.7in',
  'margin-right': '0.7in'
};

export const narrowMargins = {
  'margin-top': '0.75in',
  'margin-bottom': '0.75in',
  'margin-left': '0.25in',
  'margin-right': '0.25in'
};

export const marginStyles = {
  headerOnePage: { normalMargins, narrowMargins },
  headerAllPages: {
    normalMargins: { ...normalMargins, 'margin-top': '1.6in' },
    narrowMargins: { ...narrowMargins, 'margin-top': '1.6in' }
  }
};

// Header/Footer margins are adjusted slightly so they match the body margins
export const normalHeaderFooterMargins = {
  'margin-left': '0.53in',
  'margin-right': '0.53in'
};

export const narrowHeaderFooterMargins = {
  'margin-left': '0.19in',
  'margin-right': '0.19in'
};

export const marginTopHeader = {
  normalMargins: { 'margin-top': '0.32in !important', top: '3in' },
  narrowMargins: { 'margin-top': '0.32in !important', top: '3in' }
};

export const footerBottomMargins = {
  twoItemsStacked: '0.9in',
  threeItemsStacked: '1.1in'
};

export const mediaPrint = {
  height: 'auto'
};
